<template>
  <div class="user-page full-height aaa">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>授权</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table v-loading="loading" :data="templateList" border>
          <el-table-column label="用户名" align="center" prop="nickName" />
          <el-table-column label="邮箱" align="center" prop="email" />
          <el-table-column label="用户 id" align="center" prop="userId" />
          <el-table-column label="过期时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.expirationTime | dateFormatToDay }}
            </template>
          </el-table-column>
          <el-table-column label="taobao账号信息" align="center" prop="accountInfo" />
          <el-table-column label="taobao账号id" align="center" prop="sellerId" />
          <el-table-column label="创建时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.createTime | dateFormatToDay }}
            </template>
          </el-table-column>
          <el-table-column label="更新时间" align="center">
            <template slot-scope="scope">
              {{ scope.row.updateTime | dateFormatToDay }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="130">
            <template slot-scope="scope">
              <!-- authorizeFlag(0:授权 1:未授权) -->
              <el-button v-if="scope.row.authorizeFlag == '1'" size="small" type="primary" @click="handleObtainAuthorization">获得授权</el-button>
              <el-button v-if="scope.row.authorizeFlag == '0'" size="small" type="danger" @click="handleCancelAuthorization(scope.row)">取消授权</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </table-con>
  </div>
</template>
<script>
export default {
  name: "Authorize",
  data () {
    return {
      loading: true,
      templateList: [],
    }
  },
  created () {
    this.getList()
    this.initData()
  },
  methods: {
    async initData(){
      if(this.$route.query.code){
        const params = {
          code: this.$route.query.code
        }
        const res = await this.$http.get("/taobaoShop/callBackCode",{params})
        if(res.data.code == 200) {
          this.$message.success(res.data.msg)
          await this.getList()
        }
      }
    },
    async getList () {
      this.loading = true;
      const res = await this.$http.get("/taobaoShop/taobaoAuthorizeList")
      console.log(res,'res')
      if(res.data.code == 200) {
        this.templateList = res.data.data;
        this.loading = false;
      }
    },
    // 获取授权
    async handleObtainAuthorization () {
      const res = await this.$http.get("/taobaoShop/getAuthorize")
      if(res.data.code == 200) {
        window.location.href = res.data.data
        // window.open(res.data, '_blank');
      } else {
        this.$message.error(res.msg);
      }
    },
    // 取消授权
    async handleCancelAuthorization (e) {
      // const res = await getCancelAuthorize(e.id);
      const res = await this.$http.get(`/taobaoShop/cancelAuthorize/${e.id}`)
      if(res.data.code == 200) {
        this.$message.success(res.data.msg);
        this.getList();
      } else {
        this.$message.error(res.data.msg);
      }
    }
  }
}
</script>



<style scoped lang="less">
.aaa{
  ::v-deep .search-container{
    padding: 0;
  }
}
</style>